import { ButtonIconAction } from 'components/button/ButtonIconAction';
import { Typography } from 'enable-ui';

export const getInstitutionColumns = (
  onClickAction: (key: 'delete' | 'update-status', id: string) => void,
) => {
  return [
    {
      id: 'code',
      Header: 'Institution ID',
      width: '144px',
      minWidth: '144px',
      sort: true,
      sortType: 'code',
      Cell: ({ ...props }) => {
        const code = props.data[props.row.index]?.code;

        return <Typography style={{ textAlign: 'start' }}>{code}</Typography>;
      },
    },
    {
      id: 'name',
      Header: 'Institution',
      width: '50%',
      minWidth: '50%',
      sort: true,
      sortType: 'name',
      Cell: ({ ...props }) => {
        const name = props.data[props.row.index]?.name;

        return <Typography>{name}</Typography>;
      },
    },
    {
      id: 'email',
      Header: 'Institution admin email',
      width: '50%',
      minWidth: '50%',
      Cell: ({ ...props }) => {
        const email = props.data[props.row.index]?.email;

        return <Typography>{email}</Typography>;
      },
    },
    // {
    //   id: 'status',
    //   Header: 'Status',
    //   width: '103px',
    //   minWidth: '103px',
    //   sort: true,
    //   sortType: 'status',
    //   Cell: ({ ...props }) => {
    //     const isActive = props.data[props.row.index]?.isActive;

    //     return (
    //       <Tag
    //         color={isActive ? 'green' : 'red'}
    //         dot
    //         style={{
    //           fontWeight: 600,
    //           fontSize: 16,
    //           borderRadius: '12px',
    //           padding: '3px 8px',
    //           color: isActive ? COLOR.green['green-7'] : '',
    //         }}
    //       >
    //         {isActive ? 'Active' : 'Inactive'}
    //       </Tag>
    //     );
    //   },
    // },
    {
      id: 'action',
      Header: '',
      width: '40px',
      minWidth: '40px',
      Cell: ({ ...props }) => {
        const institutionId = props.data[props.row.index]?.id;

        // const isActive = props.data[props.row.index]?.isActive;

        return (
          <ButtonIconAction
            actions={[
              {
                label: 'Delete',
                onClick: () => onClickAction('delete', institutionId),
              },
              // isActive
              //   ? {
              //       label: 'Inactivate',
              //       onClick: () => onClickAction('update-status', institutionId),
              //     }
              //   : {
              //       label: 'Activate',
              //       onClick: () => onClickAction('update-status', institutionId),
              //     },
            ]}
          />
        );
      },
    },
  ];
};
